<div class="popup"><div class="popup__content"><div class="popup__text">{{ $t('Заполните хотя бы одно поле') }}</div></div></div>